<script setup>
import { watch, onMounted } from 'vue';
import { RouterLink, useRouter } from 'vue-router';
import { useGameTimers } from "@/composables/useGameTimers";
import { useQuizWordsStore } from "@/stores/storeQuizWords";
import { sendMetrik } from '@/utils/metrika';
import ProfileGameSessionTimer from '@/components/profile/ProfileGameSessionTimer.vue';
import ProfileGameBanner from '@/components/profile/ProfileGameBanner.vue';

const storeQuizWords = useQuizWordsStore();
const { timerPoints, timerSeries } = useGameTimers();

const router = useRouter();
const goToGameWords = () => {
    
    router.push('/quiz_words/');  
    sendMetrik('reachGoal', 'click_leaf_fall_lk')
}

watch(
	() => storeQuizWords.gameProgress,
	(progress) => {
		if (progress?.series?.points_expire_remaining_seconds) {
			timerPoints.start(progress.series.points_expire_remaining_seconds);
		}
		if (progress?.series?.series_remaining_seconds) {
			timerSeries.start(progress.series.series_remaining_seconds);
		}
	}
);


</script>
<template>
    <ProfileGameBanner goal="click_leaf_fall_lk" :active-link="!storeQuizWords.statusActive" linkUrl="/quiz_words/">
        <template #header>
            <RouterLink @click="sendMetrik('reachGoal', 'click_leaf_fall_lk')" to="/quiz_words/" class="game-banner__link">
                <svg width='24' height='24'><use href='#next'></use></svg>
            </RouterLink>
            <div @click="goToGameWords" class="game-banner__img active-link">
                <img class='full-img' width='200' height='120' src='@/assets/img/img_banner_words.webp' alt='изображение'>
            </div>
        </template>
        <template #title>Игра «Листопад»</template>
        <template #desc>Составляйте слова из букв, проходите уровни и получайте листочки</template>
        <template #sessionTimer2 v-if=" storeQuizWords.gameProgress?.series">
            <ProfileGameSessionTimer
                goal="upload_check_leaf_fall_lk"
                :time="`${timerPoints.remaining.value.hours}:${timerPoints.remaining.value.minutes}:${timerPoints.remaining.value.seconds}`"
            >
                <span class="session-timer__fire">🔥</span>
                <span class="session-timer__number">{{ storeQuizWords.gameProgress?.series?.points_earned }}</span>
                <svg width='24' height='24' class="session-timer__leaf leaf"><use href='#leaf'></use></svg>
                <span class="game-banner__timer-text">сгорят через:</span>
            </ProfileGameSessionTimer>
        </template>
        <template #sessionTimer1 v-if="storeQuizWords.gameProgress?.series?.series_remaining_seconds">
            <ProfileGameSessionTimer
                goal="click_leaf_fall_lk"
                :link="true"
                linkUrl="/quiz_words/"
                :time="`${timerSeries.remaining.value.hours}:${timerSeries.remaining.value.minutes}:${timerSeries.remaining.value.seconds}`"
            >
                <span class="game-banner__timer-text">Серия сбросится через:</span>
            </ProfileGameSessionTimer>
        </template>        
        <template #sessionTimer3 v-if="storeQuizWords.gameProgress?.series?.points_expire_remaining_seconds && !storeQuizWords.gameProgress?.series?.series_remaining_seconds">
            <span class="game-banner__timer-text --warning">❗️ Если Вы начнёте новую игру, накопленные ранее листочки сгорят.</span>
        </template>
    </ProfileGameBanner>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';

</style>